// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_3u-2";
export var blackBorderOnHover = "_3u-7";
export var cell = "_3u-6";
export var cellContainer = "_3u-3";
export var checked = "_3u-8";
export var disabled = "_3u-5";
export var featuredIconCellContainer = "_3u-9";
export var featuredIconTextContainer = "_3u-b";
export var featuredIconWrapper = "_3u-a";
export var noBorder = "_3u-c";
export var orangeSelectedRow = "_8v-3";
export var overflowableText = "_3u-0";
export var overflowableTextContainer = "_3u-1";
export var row = "_3v-0";
export var rowCheckboxCell = "_3u-4";
export var selectableTable = "_8v-2";